import React from "react";
import "./CreditCardPreview.css";

import chipImg from "../../assets/cards/chip.png";
import visaImg from "../../assets/cards/visa.png";


import mastercardImg from "../../assets/cards/mastercard.png";
import amexImg from "../../assets/cards/amex.png";
import eloImg from "../../assets/cards/elo.png";
import hipercardImg from "../../assets/cards/hipercard.png";
import defaultImg from "../../assets/logoheader.png";

const CreditCardPreview = ({ name, number, month, year, cvv }) => {
  const formatCardNumber = (num = "") => {
    return num
      .replace(/\D/g, "")
      .replace(/(.{4})/g, "$1 ")
      .trim();
  };

  const getCardBrand = (num = "") => {
    const sanitized = num.replace(/\s/g, "");

    // Elo
    if (
      /^(401178|401179|431274|438935|451416|457393|457631|457632|504175|506699|5067|509|650)/.test(
        sanitized
      )
    ) {
      return { name: "Elo", logo: eloImg };
    }

    // Visa
    if (/^4\d{0,15}$/.test(sanitized)) {
      return { name: "Visa", logo: visaImg };
    }

    // MasterCard
    if (/^(5[1-5]|2(2[2-9]|[3-6]|7[01]|720))/.test(sanitized)) {
      return { name: "MasterCard", logo: mastercardImg };
    }

    // American Express
    if (/^3[47]/.test(sanitized)) {
      return { name: "American Express", logo: amexImg };
    }

    // Hipercard
    if (/^(606282|3841|637095|637568|637599|637609|637612)/.test(sanitized)) {
      return { name: "Hipercard", logo: hipercardImg };
    }

    return { name: "Cartão", logo: defaultImg };
  };

  const { logo, name: brandName } = getCardBrand(number);

  return (
    <div className="globe-container">
      <section>
        <div className="container">
          {/* Frente */}
          <div className="card front-face">
            <header>
              <span className="logo">
                <img src={logo} alt={brandName} />
                <h5>{brandName}</h5>
              </span>
              <img src={chipImg} alt="Chip" className="chip" />
            </header>

            <div className="card-details">
              <div className="name-number">
                <h6>Número do cartão</h6>
                <h5 className="number">
                  {formatCardNumber(number) || "•••• •••• •••• ••••"}
                </h5>
                <h5 className="name">{name || "NOME DO TITULAR"}</h5>
              </div>

              <div className="valid-date">
                <h6>Validade</h6>
                <h5>
                  {month || "MM"}/{year || "AA"}
                </h5>
              </div>
            </div>
          </div>

          {/* Verso */}
          <div className="card back-face">
            <h6>
              Esta é uma representação visual do cartão. Os dados são
              confidenciais.
            </h6>
            <span className="magnetic-strip"></span>
            <div className="signature">
              <i>{cvv || "•••"}</i>
            </div>
            <h5>
              Esse cartão será criptografado e salvo no banco de dados de forma
              segura e confidencial para futuras compras!
            </h5>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CreditCardPreview;
